import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Password } from 'primereact/password';
import { ErrorValidationMessage } from '../../components/ErrorValidationMessage';
import { Toast } from 'primereact/toast';

import { useContext, useRef } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

import { Logo } from '../../components/Logo';

import '../../layout/sass/_login.scss'



export default function HomeUserPage() {

    const myToast = useRef(null);

    const showToast = (severityValue, summaryValue, detailValue) => {
        myToast.current.show({ severity: severityValue, summary: summaryValue, detail: detailValue });
    }

    const { signIn, loadingAuth } = useContext(AuthContext);

    const schema = Yup.object().shape({
        username: Yup
            .string()
            .email("O e-mail inserido é inválido")
            .required("O e-mail é obrigatório"),
        password: Yup
            .string()
            .required("A senha é obrigatória")
    })

    const formik = useFormik({
        initialValues: {
            client_id: 'Prototipo_front',
            username: '',
            password: '',
            grant_type: 'password'
        },

        validationSchema: schema,

        onSubmit: (data, { setSubmitting }) => {

            if (data.username !== '' && data.password !== '') {
                const success = signIn(data.username, data.password)
                success.then(function (result) {
                    if (!result) {
                        setSubmitting(false)
                        showToast('error', 'Login', 'Email ou senha inválido')
                    }
                })

            }
        }
    })


    return (
        <Dialog
            visible={true}
            maximized={true}
            closable={false}
            showHeader={false}
            onHide={() => null}
        >
            <Toast ref={myToast} />

            <div id="login-container" className="p-d-flex p-jc-center p-ai-center p-flex-column">
                <Logo />


                <div className="p-mb-2 p-mt-5">
                    <h2> Desculpe, mas ainda não foi atribuído perfil para o seu usuário. </h2>
                    <h2> Favor entrar em contato com a TI da prefeitura para ajuste</h2>
                </div>
            </div>
        </Dialog>
    );
}




